export const IMG = {
  hero: "https://images.unsplash.com/photo-1704040686428-7534b262d0d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
  sfold: "https://images.unsplash.com/photo-1754611362309-71297e9f42fd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  sheer: "https://images.unsplash.com/photo-1753791913941-efa7de4e1b5c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  blinds: "https://images.unsplash.com/photo-1730166890475-7de759b782b5?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  slats: "https://images.unsplash.com/photo-1778146006307-41ae8208673a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  living: "https://images.unsplash.com/photo-1704040686510-b747ff423ebb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  motor: "https://images.unsplash.com/photo-1643949914872-317d6047f107?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};

export const NAV_LINKS = [
  { id: "home", label: "Home" },
  { id: "products", label: "Products & Styles" },
  { id: "estimator", label: "Services & Pricing" },
  { id: "gallery", label: "Gallery" },
  { id: "service-area", label: "Service Area" },
  { id: "book", label: "Book Now" },
];

export const CONTACT = {
  phone: "0450 742 260",
  email: "kent@happy23blinds.com",
  address: "U2 326 Springfield Rd, Nunawading VIC 3131",
  abn: "ABN 85 701 654 542",
};

export const PRODUCT_GROUPS = [
  {
    title: "Curtain Styles",
    items: [
      { name: "S-Fold (Wave)", desc: "Continuous soft waves on a slim ceiling or wall track. The signature of modern Melbourne interiors.", img: IMG.sfold, tag: "Most popular" },
      { name: "Pinch Pleat", desc: "Tailored, hand-finished pleats with a classic, structured drape.", img: IMG.living },
      { name: "Eyelet", desc: "Clean rings on a rod — relaxed, budget-friendly and effortless to hang.", img: IMG.sheer },
    ],
  },
  {
    title: "Fabrics",
    items: [
      { name: "Sheer Curtains", desc: "Diffused daylight and privacy with linen-look and voile weaves.", img: IMG.sheer },
      { name: "Blockout Curtains", desc: "Total darkness, thermal insulation and acoustic softening.", img: IMG.hero },
      { name: "Double Layers", desc: "Sheer plus blockout on a dual track for day-to-night control.", img: IMG.sfold, tag: "Best value" },
    ],
  },
  {
    title: "Hardware & Tracks",
    items: [
      { name: "Roman Rods", desc: "Brass, matte black and brushed nickel rods with finials to suit.", img: IMG.blinds },
      { name: "Motorized Smart Tracks", desc: "Whisper-quiet motors. Google Home, Alexa and app scheduling.", img: IMG.motor, tag: "Smart home" },
      { name: "Plantation Shutters", desc: "PVC, basswood and aluminium shutters, hinged, bi-fold or sliding.", img: IMG.slats },
    ],
  },
];

export const GALLERY = [
  { cat: "Living Room", title: "Toorak sheer S-Fold", img: IMG.sfold, span: "lg:col-span-2 lg:row-span-2" },
  { cat: "Bedroom", title: "Brighton blockout & sheer", img: IMG.hero },
  { cat: "Motorized", title: "South Yarra smart track", img: IMG.motor },
  { cat: "Shutters", title: "Hawthorn plantation shutters", img: IMG.slats },
  { cat: "Living Room", title: "Kew linen drapes", img: IMG.living, span: "lg:col-span-2" },
  { cat: "Bedroom", title: "Mornington dual roller", img: IMG.blinds },
  { cat: "Motorized", title: "Docklands penthouse", img: IMG.sheer },
];

export const GALLERY_TABS = ["All", "Living Room", "Bedroom", "Motorized", "Shutters"];

export const MARQUEE_ITEMS = [
  "Toorak", "Brighton", "South Yarra", "Hawthorn", "Kew", "Mornington Peninsula", "Camberwell", "Malvern",
  "Docklands", "Williamstown", "Essendon", "Doncaster", "Berwick", "Point Cook",
];

export const PROCESS = [
  { n: "01", title: "Choose & Estimate Online", desc: "Explore styles, then use our estimator to get a transparent price range in under two minutes — no obligation." },
  { n: "02", title: "Free On-Site Measure & Fabric Swatches", desc: "A local consultant visits with fabric books and hardware samples, laser-measures every window and confirms your quote." },
  { n: "03", title: "Professional Installation & Guaranteed Finish", desc: "Made-to-measure in 3–4 weeks. Our installers fit, level and child-safety certify every treatment, backed by warranty." },
];

export const TIME_SLOTS = ["Morning · 8am – 11am", "Midday · 11am – 2pm", "Afternoon · 2pm – 5pm", "Evening · 5pm – 7pm", "Saturday · 9am – 1pm"];
